import React, { useState, useEffect, Fragment } from 'react'
import { Card, Typography, Menu, Dropdown, Layout, Row, Col, Button, Input, Table, Modal, message, Upload } from 'antd';
import { Link, Redirect } from 'react-router-dom';
import Axios from 'axios';
import moment from 'moment';
import { url } from '../../config/global'
import { MoreOutlined, EditOutlined, DeleteOutlined, PlusOutlined, InfoCircleOutlined, ImportOutlined, ExportOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import './MasterPantry.less'
import fileDownload from 'js-file-download';

const { Title } = Typography
const { Search } = Input
const { Content } = Layout
const { Dragger } = Upload


function MasterPantry() {

	const [keyword, setKeyword] = useState('')
	const [dataPantry, setDataPantry] = useState([])
	const [loading, setLoading] = useState(false)
	const [page, setPage] = useState(1)
	const [sort, setSort] = useState({
		sort: 'name',
		order: 'ascend'
	})
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [error, setError] = useState(null);
	const [data, setData] = useState({
		file: null,
	});

	const [buttonAccess, setButtonAccess] = useState(null);

	const handleSearch = (value) => {
		setKeyword(value)
		setPage(1)
	}

	useEffect(() => {
		getData(keyword, page, sort)

		const pathname = window.location.pathname.split("/");
		const currentUrl = pathname[1];

		const permissions =
			localStorage.getItem("permissions") &&
			JSON.parse(localStorage.getItem("permissions"));

		if (permissions) {
			const findPermission = permissions.find(
				(permission) => permission.url === currentUrl
			);
			const findChildPermission = permissions
				.map((child) => {
					return child.children.find(
						(grandChild) => grandChild.url === currentUrl
					);
				})
				.filter((grandChild) => grandChild)[0];

			if (findChildPermission && findChildPermission.children) {
				if (findChildPermission.children) {
					const findButtonAccessChildren = findChildPermission.children
						.filter((x) => x !== null)
						.filter((x) => x.permission_type === "button");
					if (findButtonAccessChildren) {
						setButtonAccess(findButtonAccessChildren.filter((x) => x !== null));
					}
				}
			}
		}
	}, [keyword, page, sort])

	const handleRemove = () => {
		setData({
			...data,
			file: null,
		});
	};

    const handleCloseModal = () => {
        getData()
        setIsModalVisible(false)
    }

    const responseUpload = (e) => {

        if (typeof e.file.response !== "undefined") {
            let res = e.file.response
            if (res.result) {
                message.success(res.message)
            } else {
				message.error(res.message)
            }
        }
    }

	const showModal = () => {
		setIsModalVisible(true);
	};

	const exportData = () => {
		setLoading(true)

		Axios.get(`${url}/pantry/export`, {
			responseType: 'blob',
			headers: {
				"Content-Type": "application/vnd.ms-excel",
				Authorization: `Bearer ${localStorage.getItem('token')}`,
			}
		})
			.then((res) => {
				message.success('File downloaded')
				fileDownload(res.data, "Export Pantry" + ".xlsx");
			}).catch(err => {
				if (err.response) {
					message.error(err.response.data.message)
					if (err.response.status == 401) {
						localStorage.removeItem('token')
					}
				}
			}).finally(() => {
				setLoading(false)
			})
	}

	const getData = () => {
		setLoading(true)
		Axios.get(`${url}/pantry`, {
			params: {
				keyword,
				columns: [
					'name',
					'description',
					'type'
				],
				perpage: 10,
				page,
				sort: sort.sort,
				order: sort.order
			},
			headers: {
				Authorization: `Bearer ${localStorage.getItem('token')}`
			}
		}).then(res => {
			// console.log('ini res nya',res)
			setDataPantry(res.data)
		}).catch(err => {
			if (err.response) {
				message.error(err.response.data.message)
				if (err.response.status == 401) {
					localStorage.removeItem('token')
				}
			}
		}).finally(() => {
			setLoading(false)
		})
	}

	const handleDelete = (id) => {

		Modal.confirm({
			icon: <ExclamationCircleOutlined />,
			title: 'Are you sure?',
			content: (
				<div>
					<p>Deleted data cannot be restored</p>
				</div>
			),
			okText: 'Delete',
			showCancel: true,
			onCancel: () => {
				return
			},
			cancelText: 'Cancel',
			confirmLoading: loading,
			onOk: async () => {
				confirmDelete(id)
			}
		})
	}

	const confirmDelete = (id) => {

		setLoading(true)
		Axios.delete(`${url}/pantry/${id}`, {
			headers: {
				Authorization: `Bearer ${localStorage.getItem('token')}`
			}
		}).then(res => {
			message.success(res.data.message)
			getData(keyword, page, sort)
		}).catch(err => {
			if (err.response) {
				message.error(err.response.data.message)
				if (err.response.status == 401) {
					localStorage.removeItem('token')
				}
			}
		}).finally(() => {
			setLoading(false)
		})
	}

	const handleTableChange = (pagination, filters, sorter) => {
		setPage(pagination.current)
		setSort({
			sort: sorter.field,
			order: sorter.order
		})
	}

	const columns = [
		{
			title: 'name',
			dataIndex: 'name',
			sorter: true
		},
		{
			title: 'Description',
			dataIndex: 'description',
			sorter: true
		},
		{
			title: 'Type',
			dataIndex: 'type',
			sorter: false,
		},
		{
			title: '',
			dataIndex: '_id',
			align: 'right',
			sorter: false,
			width: 100,
			render: (id) => {

				return (
					<Fragment>
						<Dropdown className="pointer" overlay={
							<Menu>
								{buttonAccess &&
									buttonAccess.find((x) => x.url === "master-pantry/view") && (
										<Menu.Item key="0">
											<Link to={`/master-pantry/view/${id}`}><InfoCircleOutlined /> View</Link>
										</Menu.Item>
									)}
								{buttonAccess &&
									buttonAccess.find((x) => x.url === "master-pantry/edit") && (
										<Menu.Item key="1">
											<Link to={`/master-pantry/edit/${id}`}><EditOutlined /> Edit</Link>
										</Menu.Item>
									)}
								{buttonAccess &&
									buttonAccess.find((x) => x.url === "master-pantry/delete") && (
										<Menu.Item key="3">
											<span onClick={() => handleDelete(id)}><DeleteOutlined />Delete</span>
										</Menu.Item>

									)}
							</Menu>
						} trigger={['click']}>
							<span className="pointer" onClick={e => e.preventDefault()}>
								<MoreOutlined />
							</span>
						</Dropdown>
					</Fragment>
				)
			}
		}
	]

	if (!localStorage.getItem('token')) {
		return <Redirect to="/login" />
	}

	return (
		<Fragment>
			<Row>
				<Col xs={24}>
					<Card type="inner" title="Pantry" extra={moment(new Date()).format('DD MMMM YYYY')}></Card>
				</Col>
			</Row>
			<Content className="content">
				<Modal
					title="Upload Data"
					centered
					visible={isModalVisible}
					onOk={() => handleCloseModal()}
					onCancel={() => setIsModalVisible(false)}
				>
					<Button href="/files/PantriesTemplate.xlsx" style={{ marginRight: 10 }}>Download Template</Button>
					<hr
						style={{
							borderWidth: 1,
							borderStyle: 'solid',
							borderColor: '#eee',
						}}
					/>
					<Dragger
						name='file'
						action={url + '/pantry/import'}
						headers={{
							Authorization: `Bearer ${localStorage.getItem('token')}`
						}}
						onChange={(e) => responseUpload(e)}
					>
						<p className="ant-upload-text">Click or drag file to this area to upload</p>
					</Dragger>
				</Modal>
				<Card className="body-data">
					<div className='wrapperBtn'>
						<div className='left'>
							{buttonAccess &&
								buttonAccess.find((x) => x.url === "master-pantry/create") && (
									<Link to="/master-pantry/create">
										<Button type="primary" className='btn'><PlusOutlined />Add Pantry</Button>
									</Link>

								)}
							{buttonAccess &&
								buttonAccess.find((x) => x.url === "master-pantry/import") && (
									<Button type="primary" className='btn' onClick={showModal}>
										<ImportOutlined />
										Import
									</Button>
								)}
							{buttonAccess &&
								buttonAccess.find((x) => x.url === "master-pantry/export") && (
									<Button type="primary" className='btn' onClick={exportData}>
										<ExportOutlined />
										Export
									</Button>
								)}
						</div>
						<div className='right'>
							<Search
								placeholder="Search ..."
								// onSearch={(value) => handleSearch(value)}
								onChange={(e) => handleSearch(e.currentTarget.value)}
							/>
						</div>
					</div>
					<Row>
						<Col xs={24} style={{ overflowX: 'auto' }}>
							<Table
								columns={columns}
								dataSource={dataPantry.data}
								rowKey={(data) => data._id}
								onChange={handleTableChange}
								pagination={{ pageSize: 10, current: page, total: dataPantry.total, showSizeChanger: false }}
								loading={loading}
							/>
						</Col>
					</Row>
				</Card>
			</Content>
		</Fragment>
	)
}



export default MasterPantry
